let options

function Log(opt) {
  options = opt
  return Log
}
Log.install = function (Vue) {
  function log(...msg) {
    if (!Vue.config.productionTip) {
      // console.log(...msg)
    }
  }
  Object.defineProperty(Vue.prototype, "$log", {
    get() {
      return log
    }
  })
  window.$log = log
}
export default Log



// WEBPACK FOOTER //
// ./src/plugin/vue-log.js